import { render, staticRenderFns } from "./PUserPassEdit.vue?vue&type=template&id=9cda3604&"
import script from "./PUserPassEdit.vue?vue&type=script&lang=ts&"
export * from "./PUserPassEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports